import { format, parseISO } from 'date-fns';
import React from 'react';
import { getLocale, isTodayFormat } from '../../helpers/dates';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import styles from './ReservationItem.module.css';

const ReservationItemAgency = ({ activity, handleClick, date }) => {
  const app = useSelector((state) => state.app);
  const locale = getLocale(app.language);
  const { t } = useTranslation();

  return (
    <div className='row'>
      <div className={`col-12 pb-2 mb-2 ${styles.borderBottom}`} onClick={handleClick}>
        <div className='row'>
          <div className='col-auto pr-0 my-auto'>
            {' '}
            <div className={`${styles.logoBorder}`}>
              <img
                className={styles.restaurantImg}
                src={activity.showImage}
                alt='logo'
              />
            </div>
          </div>
          <div className='col'>
            {activity.eventShow ? (
              <div className='fw-700'>{activity.restaurantName}</div>
            ) : (
              <div className={`${styles.activityItemInfo} fw-700`}>
                {activity.restaurantName || activity.showName}
              </div>
            )}
            <div className='subtitle-text'>
              {activity?.customerName} x {activity.pax || activity.paxs}
            </div>
          </div>
          <div className='col-auto fw-500 text-right text-secondary pl-0'>
            <div>{isTodayFormat(date, locale, t, activity.isToday)}</div>
            <div>{format(parseISO(date), 'HH:mm', { locale })}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReservationItemAgency;
